import HomeComponent from 'projectComponent/Home/HomeComponent'

const Home = () => <HomeComponent />

export default Home